import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const colors = constants.colors;
// Colors based on the image
const coreBlue = { 700: "#0052C4", 500: "#106FF3" };
const black = colors.ui.black[500];
const white = colors.ui.white[500];
const neutral400 = colors.ui.neutral[400];
const primaryColor = coreBlue[500];
const borderColor = primaryColor;

export const containerStyles: CSSObject = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  backgroundColor: white,
  padding: "16px",
  boxSizing: "border-box",
};

export const formGridStyles: CSSObject = {
  display: "grid",
  gridTemplateAreas: `
    "quadrant-top-left quadrant-top-right"
    "quadrant-bottom-left quadrant-bottom-right"
  `,
  gridTemplateColumns: "1fr 1fr",
  gridTemplateRows: "1fr 1fr",
  gap: 0,
  position: "relative",
  marginTop: "36px",
};

const borderStyle = `2px solid ${borderColor}`;

export const quadrantStyles: CSSObject = {
  border: `4px solid ${borderColor}`,
  borderRadius: "8px",
  padding: "0 16px",
  display: "flex",
  flexDirection: "column",
  backgroundColor: white,

  "&.quadrant-top-left": {
    gridArea: "quadrant-top-left",
    flexDirection: "column",
    borderBottom: borderStyle,
    borderRight: borderStyle,
    paddingBottom: "65px",
  },
  "&.quadrant-top-right": {
    gridArea: "quadrant-top-right",
    flexDirection: "column",
    alignItems: "end",
    borderBottom: borderStyle,
    borderLeft: borderStyle,
  },
  "&.quadrant-bottom-left": {
    gridArea: "quadrant-bottom-left",
    flexDirection: "column-reverse",
    borderTop: borderStyle,
    borderRight: borderStyle,
    paddingTop: "65px",
  },
  "&.quadrant-bottom-right": {
    gridArea: "quadrant-bottom-right",
    flexDirection: "column-reverse",
    alignItems: "end",
    borderTop: borderStyle,
    borderLeft: borderStyle,
    paddingTop: "65px",
  },
};

const quadrantLabelStyles: CSSObject = {
  ...typographyStyles.heading4Obj,
  fontWeight: 700,
  color: black,
};

export const topQuadrantLabelStyles: CSSObject = {
  ...quadrantLabelStyles,
  marginBottom: "8px",
};

export const bottomQuadrantLabelStyles: CSSObject = {
  ...quadrantLabelStyles,
  marginTop: "8px",
};

export const quadrantTextareaStyles: CSSObject = {
  border: `1px solid ${neutral400}`,
  borderRadius: "8px",
  padding: "8px 12px",
  resize: "none",
  height: "100%",
  maxHeight: "85px",
  overflowY: "hidden",
  width: "100%",
  ...typographyStyles.textMObj,
};

export const wordWrapperStyles: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: "1",
  background: white,
  borderRadius: "60px",
  border: `4px solid ${borderColor}`,
  padding: "20px 30px",
  width: "calc(100% - 120px)",
  maxWidth: "100%",
  height: "110px",
  justifyContent: "center",
  boxSizing: "border-box",
};

export const wordInputStyles: CSSObject = {
  border: `1px solid ${neutral400}`,
  borderRadius: "8px",
  textAlign: "center",
  fontWeight: "bold",
  width: "100%",
  height: "100%",
  background: "transparent",
  ...typographyStyles.heading2Obj,
  ...typographyStyles.fontFamily.circular,
};

export const paragraphCss: CSSObject = {
  margin: 0,
  textAlign: "center",
  fontWeight: "bold",
  ...typographyStyles.heading2Obj,
  ...typographyStyles.fontFamily.circular,
};
